import React, { useRef, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";

import "../styles/AboutUs.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import { Link } from "react-router-dom";

import "../styles/Aerospace.css";
import { useState } from "react";
import ActionButton1 from "../utils/ActionButton";
import LandingSection from "../components/LandingSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faIndustry,
  faChartLine,
  faCogs,
  faLightbulb,
} from "@fortawesome/free-solid-svg-icons";
import { AerospaceFaqSection } from "./AerospaceFaqSection";
import ModalFunction from "./Modal";
import Footer from "../components/Footer";
import TabTitle from "../components/TabTitle";
import DataSources from "../components/DataSources";

const logo = "/img/1.png";
const kpi = "/img/KPI-DASH 2.png";
const aerospace = "/img/Aerospace.webp";

export default function Aerospace() {
  const navbarRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);

  // Close dropdown when clicking outside the navbar
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close the navbar on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        const navbarCollapse =
          navbarRef.current.querySelector(".navbar-collapse");
        if (navbarCollapse) {
          navbarCollapse.classList.remove("show"); // Close the navbar
        }
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (


    <div>
      <LandingSection
        data={{ imageName: "aerospace.webp", title: "Aerospace and Defense" }}
      />
      <div className="verticals_section">
        <div className="verticals-intro">
          <div className="verticals-intro-sec1">
            <h2>A hub of innovation and growth.</h2>
          </div>
          <div className="verticals-intro-sec2">
            <p>
              Utah’s aerospace and defense industry is a vital pillar of the state's economy, supporting thousands of high-paying jobs. With key military installations like Hill Air Force Base and a strong presence of major contractors such as Northrop Grumman and Lockheed Martin, Utah plays a central role in national defense. The state excels in advanced manufacturing, testing, and innovation across aerospace systems. Utah’s skilled workforce and pro-business environment continue to attract new investments in this strategic sector.

            </p>

          </div>
        </div>
      </div>
    
      <div className="flex justify-center items-center px-4">
        <Link
          to="/verticals/hill-airforce-base-economic-impact"
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg mx-auto text-center"
        >
          <div className="w-full">
            <ActionButton1 data={"Hill Air Force Base Economic Impact"} />
          </div>
        </Link>
      </div><br/>
        <TabTitle />
      <AerospaceFaqSection />
      <DataSources
        sources={[
          "https://ledextract.ces.census.gov/qwi/all",
          "https://www.trade.gov/data-visualization/aerospace-and-defense-data",
          "https://www.aia-aerospace.org/wp-content/uploads/Facts-Figures-Report-2023-State-Data.pdf",
          "https://gardner.utah.edu/utah-economy/industry-impact-studies/defense-and-aerospace/",
          "https://www.edcutah.org/research/research-main",
          "https://nuea.org/2024/11/21/northern-utah-2024-aerospace-defense-profile/",
        ]}
      />
      <Footer />
    </div>


  );
}
